import { DefaultNodeData, getAssetTypeFromAppId } from "@zapier/canvas-state";
import { Node, NodeProps } from "@xyflow/react";

import { DefaultNodeContentInner } from "../DefaultNode/DefaultNodeContent";
import { TableNode } from "../TableNode";
import { InterfaceNode } from "../InterfaceNode";
import { ChatbotNode } from "../ChatbotNode";

import { AssetNodeSkeleton } from "./AssetNodeSkeleton";
import { AgentNode } from "../AgentNode";

export interface AssetNodeProps {
  className: string;
  isViewOnlyMode?: boolean;
  backgroundColor?: string;
}

export function AssetNodeDeterminer(
  props: NodeProps<Node<DefaultNodeData>> & AssetNodeProps,
) {
  const appId = props.data.services?.[0]?.currentImplementation?.id ?? "";
  const assetType = getAssetTypeFromAppId(appId);

  if (assetType === "table") {
    return <TableNode {...props} />;
  }

  if (assetType === "interface") {
    return <InterfaceNode {...props} />;
  }

  if (assetType === "chatbot") {
    return <ChatbotNode {...props} />;
  }

  if (assetType === "agent") {
    return <AgentNode {...props} />;
  }

  if (appId) {
    return <AssetNodeSkeleton {...props} />;
  }

  return <DefaultNodeContentInner {...props} />;
}
